<template>
     <div>
        <p v-if="!dataLoaded">Loading...</p>
        <table v-if="dataLoaded">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Price</th>
                    <th>Lockers</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="mod in modules" :key="mod.id">
                    <td><router-link :to="'/lockermodules/'+mod.id">{{mod.name}}</router-link></td>
                    <td>{{mod.is_kiosk ? "Kiosk" : "Module"}}</td>
                    <td>${{mod.price.toFixed(2)}}</td>
                    <td>{{mod.num_lockers}}</td>
                    <td><button @click="delMod(mod.id)">Delete</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {CallApi} from '../Utilities.js'

    export default {
        name: 'ModuleList',
        data: function() {
            return {
                dataLoaded: false,
                modules: []
            }
        },
        methods: {
            delMod: async function(id) {
                if (confirm("Are you sure you wish to delete this Module?")) {
                    await CallApi('DELETE', `/modules/${id}`)
                }
                
                this.modules = (await CallApi('GET', '/modules')).modules
                this.dataLoaded = true
            },
            fetchData: async function() {
                this.modules = (await CallApi('GET', '/modules')).modules
                this.dataLoaded = true
            }
        },
        mounted: function () {
            this.fetchData()
        }
    }
</script>